<template>
  <HUINavbarButtonCart :count="totalQuantity" :price="totalPrice"></HUINavbarButtonCart>
</template>

<script>
import { mapState } from 'vuex'
import { HUINavbarButtonCart } from '@/halifax-ui'
import routes from '@/router/routes'

export default {
  components: {
    HUINavbarButtonCart
  },
  data() {
    return {
      totalQuantity: 0
    }
  },
  computed: {
    ...mapState('booking', {
      bookings: 'bookings'
    }),
    ...mapState('order', {
      orders: 'orders'
    }),
    totalPrice() {
      let { orderToken, bookingToken } = this.$route.params
      if (bookingToken && this.bookings) {
        const booking = this.bookings.find(booking => booking.token === bookingToken)
        orderToken = booking && booking.order_token
      }
      const order = this.orders[orderToken]

      if (!order) {
        return 0
      }
      let totalQuantity = 0
      const price = orderToken
        ? order.order_lines.reduce((accumulatedPrice, orderLine) => {
            accumulatedPrice += orderLine.price || 0

            if (!orderLine.prepared_at) {
              totalQuantity += orderLine.quantity || 1
            }
            return accumulatedPrice
          }, 0)
        : 0
      this.totalQuantity = totalQuantity
      return price
    }
  }
}
</script>

<style lang="scss">
</style>
